import React from "react";
import Seo from "@/utils/seo";
import BannerCard from "@/components/ui/banner-card";
import Vision from "@/components/pages/who-we-are/vision";
import Values from "@/components/pages/who-we-are/values";
import Head from "next/head";
import Problem from "@/components/pages/initiatives/problem";
import Team from "@/components/pages/who-we-are/team";
import Board from "@/components/pages/who-we-are/board";
import { leadership } from "@/data/leadership-data";
import { board } from "@/data/board-data";
import HowWeDoIt from "@/components/pages/who-we-are/how-we-do-it";
import WhatWeDo from "@/components/pages/who-we-are/what-we-do";
import HowItStarted from "@/components/pages/who-we-are/how-it-started";
export default function Home() {
  const seo = {
    slug: "/who-we-are",
    metaTitle:
      "Top Non Profit Organizations in USA | People’s Courage International",
    metaDescription:
      "People’s Courage International seeks to end violence against women and children. It aims to ensure safe migration and labor security for the most disadvantaged social groups.",
  };
  const jsonLd = {
    "@context": "http://www.schema.org",
    "@type": "Organization",
    name: "People’s Courage International",
    description:
      "People’s Courage International is a USA-based not-for-profit organization. Join our charity and help us provide critical support to those in need around the world.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "3206 10th Street NE, Washington",
      addressLocality: "DC",
      postalCode: "20017",
      addressCountry: "USA",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+1202-573-8727",
      contactType: "customer support",
    },
  };

  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd),
          }}
        />
      </Head>
      <BannerCard
        banner={{
          title: "Who We Are",
          image: "/images/about/about-banner.webp",
        }}
        isActive={true}
        variant="single"
        anchor="how-it-started"
      />

      <HowItStarted />
      <WhatWeDo />
      <HowWeDoIt />
      <Vision />
      <Values />
      {/* <Team title="Our Leadership" data={leadership} className="bg-[#F4F9FF]" /> */}
      {/* <Board title="Our Board" data={board} /> */}
    </>
  );
}
